import type { ReactNode } from "react";

import { AuthCta } from "@/landing/wab/components/AuthCta";
import { Silk } from "@/landing/wab/components/Silk";

type PrefooterProps = {
  title?: string;
  showInstall?: boolean;
  signedOutLabel?: string;
  signedInLabel?: string;
  ctaHref?: string;
  ctaNode?: ReactNode;
};

export function Prefooter({
  title = "The safest way to automate your LinkedIn, X and Reddit flows using Claude, Codex or Openclaw",
  showInstall = true,
  signedOutLabel = "Start now",
  signedInLabel,
  ctaHref,
  ctaNode,
}: PrefooterProps = {}) {
  return (
    <section className="prefooter">
      <div className="prefooter-card reveal">
        <div className="pf-silk" aria-hidden="true">
          <Silk />
        </div>
        <div className="pf-content">
          <h2 className="prefooter-title">{title}</h2>
          <p className="prefooter-sub">One plan, $49.99/mo. No usage limits.</p>
          {showInstall && (
            <div className="pf-term">
              <span className="pf-dollar">$</span>
              <span className="pf-cmd">
                curl -fsSL https://wonda.sh/install.sh | bash
              </span>
            </div>
          )}
          {ctaNode ??
            (ctaHref ? (
              <a href={ctaHref} className="prefooter-cta">
                {signedOutLabel} <span className="arr">→</span>
              </a>
            ) : (
              <AuthCta
                className="prefooter-cta"
                signedOutLabel={signedOutLabel}
                signedInLabel={signedInLabel}
              />
            ))}
        </div>
      </div>
    </section>
  );
}
